export default __webpack_public_path__ + "static/media/newjersey.dce4f0cd.jpg";